module.exports = __webpack_public_path__ + "media/application/images/reviews/inactive-45214e9eb80f72abc72d30a51170251b.png";